



























































































































































































import { defineComponent, onMounted, ref } from "vue-demi";
import router from "./router";
import { useAuthStore } from "./stores/authStore";
import { setI18nLocale } from "./plugins/i18n";
import AppLogo from "./AppLogo.vue";
import LanguageToggle from "./components/LanguageToggle.vue";

export default defineComponent({
  name: "PatientSite",
  components: { AppLogo, LanguageToggle },
  props: {},
  setup(props) {
    const authStore = useAuthStore();
    authStore.setupRecaptcha();

    const showLayout = ref(true);
    function updateLayoutState() {
      // only show layout if not in an iframe
      showLayout.value =
        (router.currentRoute.meta?.showLayout ?? true) == true &&
        window.top == window.self;
    }
    router.afterEach(updateLayoutState);
    onMounted(updateLayoutState);

    const isLoggedIn = ref(false);
    let preferredLanguageApplied = false;
    let queryLanguageApplied = false;
    async function checkIsLoggedIn() {
      isLoggedIn.value = await authStore.isLoggedIn();
      // A returning, already-authenticated session (no fresh login call) still needs
      // its language applied once on app boot; only do this once per session. A real
      // patient's stored preference always wins over a ?language= query param.
      if (isLoggedIn.value && !preferredLanguageApplied) {
        preferredLanguageApplied = true;
        authStore.applyPreferredLanguage();
      } else if (!isLoggedIn.value && !queryLanguageApplied) {
        // Pre-login (e.g. a public interaction link emailed right after marketing-site
        // registration), there's no patient record yet to read a preference from — but
        // the marketing site already captured one, so it's passed through as a query
        // param instead. Apply it once; don't persist it (no patient to persist against
        // yet, and login will overwrite this with the real stored preference anyway).
        const queryLanguage = router.currentRoute.query?.language;
        if (typeof queryLanguage === "string" && queryLanguage) {
          queryLanguageApplied = true;
          setI18nLocale(queryLanguage);
        }
      }
    }

    router.afterEach(() => checkIsLoggedIn());
    checkIsLoggedIn();

    const currentYear = new Date().getFullYear();

    const homeUrl = new URL(
      process.env.VUE_APP_MARKETING_SITE_REGISTER_URL ?? window.location.href
    ).origin;

    const marketingRegisterUrl =
      process.env.VUE_APP_MARKETING_SITE_REGISTER_URL ?? window.location.href;

    return {
      showLayout,
      isLoggedIn,
      currentYear,
      homeUrl,
      marketingRegisterUrl,
    };
  },
});
